module.exports = __webpack_public_path__ + "img/no necesitas experiencia bancaria.4456e318.svg";